import {Entity} from "myfitworld-model";

export const isMFWExercise = (entity: Entity, entityName:string, currentOrgId: string|undefined): boolean => {
  return (entity?.organizationId !== currentOrgId && entity?.organizationId === process.env.REACT_APP_MFW_ORGANIZATION_ID && (entityName === 'Exercise' || entityName === 'Vežba'));
};
